// extracted by mini-css-extract-plugin
export default {"root":"ShopNav_root__jaal3","tab":"ShopNav_tab__HDClk"};